import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => ({
	// Figma H5, matching the other refreshed pages — variant="h6" resolves to 16px (MAX-4176).
	sectionHeader: {
		fontSize: 18,
		lineHeight: "24px",
		fontWeight: 700,
		color: theme.palette.custom.textPrimary,
	},
	sectionHeaderRow: {
		display: "flex",
		alignItems: "center",
		gap: 8,
		marginBottom: 24,
	},
	// Same treatment as the Round Robin "Next up" chip — pale teal pill with slate text.
	priorityBadge: {
		height: 28,
		backgroundColor: baseColors.teal25,
		borderRadius: 16,
		padding: theme.spacing(0.5, 1.5),
		"& .MuiChip-label": {
			fontSize: 13,
			lineHeight: "20px",
			fontFamily: theme.typography.fontFamily,
			fontWeight: 400,
			color: baseColors.slateTeal,
			padding: 0,
		},
	},
} satisfies Record<string, CSSObject>);
